import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ConfirmComponent } from '../../shared/components/confirm/confirm.component';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
	private modalOpen = false;

	constructor(private modalService: NgbModal) {}

	displayErrorMessage(errorMessage: string, errorTitle?: string) {
		if (this.modalOpen) {
			return;
		}
		this.modalOpen = true;
		const modalRef = this.modalService.open(ConfirmComponent, {
			windowClass: 'modal-small',
			centered: true,
			backdrop: 'static',
			keyboard: false
		});
		modalRef.componentInstance.title = errorTitle ? errorTitle : '¡Error!';
		modalRef.componentInstance.body = errorMessage;
		modalRef.componentInstance.buttonText = 'Volver al listado';
		modalRef.result.then(
			(result) => {
				this.modalOpen = false;
			},
			(reason) => {
				//  Dismiss
				this.modalOpen = false;
			}
		);
	}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(req).pipe(
			catchError((err) => {
				console.warn(`Interceptor: ${JSON.stringify(err)}`);
				let errorTitle: string = '';
				let errorMessage: string;
				switch (err.status) {
					//Errores de cliente: 400, 401, ..., 499
					case 400:
						errorMessage = 'La sintaxis de la petición no es válida para el servidor.';
						break;
					case 403:
						errorMessage = 'Prohibido el acceso a los recursos';
						break;
					case 404:
						errorMessage = 'El recurso solicitado no ha sido encontrado.';
						break;
					case 409:
						errorTitle = '¡Aviso!';
						errorMessage = 'Hay un conflicto en el estado actual del recurso';
						break;
					case 413:
						errorMessage = 'El contenido de la petición es demasiado grande para ser gestionado por el servidor.';
						break;
					case 415:
						errorMessage = 'Formato multimedia de la solicitud no soportado por el servidor.';
						break;
					case 429:
						errorMessage = 'Se han enviado demasiadas peticiones al servidor en poco tiempo.';
						break;
					//Errores de servidor: 500, 501, ..., 599
					case 500:
						errorMessage = 'El servidor no ha podido gestionar adecuadamente la petición mandada.';
						break;
					case 503:
						errorMessage =
							'El servidor no se encuentra actualmente disponible para gestionar la petición. Por favor, inténtelo de nuevo más tarde.';
						break;
					case 504:
						errorMessage = 'Tiempo de espera por respuesta de servidor excedido.';
						break;
					default:
						errorMessage = `Se ha producido un error no contemplado:\n${err.message}`;
				}
				errorTitle
					? this.displayErrorMessage(errorMessage, errorTitle)
					: this.displayErrorMessage(`Error ${err.status}\n${errorMessage}`);
				const error = err;
				return throwError(error);
			})
		);
	}
}
